import React from "react";

// Renderiza una plantilla con placeholders {token} intercalando nodos React
// (ej. <strong>, spans coloreados) en vez de concatenar strings — así la
// traducción completa vive en una sola clave por idioma, con la gramática y
// el orden de palabras correctos para cada idioma.
export function renderTemplate(template, tokens) {
  return template.split(/(\{\w+\})/g).map((part, i) => {
    const match = part.match(/^\{(\w+)\}$/);
    if (!match) return part;
    return <React.Fragment key={i}>{tokens[match[1]]}</React.Fragment>;
  });
}

// Versión de renderTemplate para contextos de texto plano (toasts, aria-label,
// atributos) donde no se pueden intercalar nodos React — reemplaza {token} por
// el valor tal cual (stringificado).
export function fillTemplate(template, tokens) {
  return template.replace(/\{(\w+)\}/g, (_, key) => (tokens[key] ?? ""));
}
